export default "__VITE_ASSET__5e2ec9e7__"